import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","fill":"currentColor","key":"svg-0"}]]

const IconPercentage100 = createReactComponent('outline', 'percentage-100', 'Percentage100', __iconNode);

export default IconPercentage100;